var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sc-message--text",
      class: {
        translatable: _vm.isTranslatable(),
        emoji: _vm.isEmoji(),
      },
      style: Object.assign(
        {},
        _vm.messageColors,
        //backgroundColor: determineColor(message),
        _vm.extendedStyle || {},
        {
          "background-color": _vm.isEmoji()
            ? "transparent"
            : _vm.messageColors.backgroundColor,
        }
      ),
    },
    [
      _vm.message.raw.replyTo && !_vm.replyMode
        ? _c("QuoteMessage", { attrs: { message: _vm.message.raw.replyTo } })
        : _vm._e(),
      _vm._v(" "),
      [
        _c(
          "div",
          {
            staticClass: "sc-message--toolbox",
            style: { background: _vm.messageColors.backgroundColor },
          },
          [
            _vm.me && _vm.message.id != null && _vm.message.id != undefined
              ? _c(
                  "button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.$emit("remove")
                      },
                    },
                  },
                  [
                    _c(
                      "icon-base",
                      {
                        attrs: {
                          color: _vm.messageColors.color,
                          "icon-name": "remove",
                          width: "10",
                        },
                      },
                      [_c("icon-cross")],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._t("text-message-toolbox", null, {
              me: _vm.me,
              message: _vm.message,
            }),
          ],
          2
        ),
      ],
      _vm._v(" "),
      _vm.isGroupMessage
        ? _c(
            "span",
            {
              staticClass: "whatsapp-number-first",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  _vm.showWhatsappChatStarterModal = true
                },
              },
            },
            [
              _c(
                "a",
                {
                  style: { color: _vm.getWhatsappNumberColor() },
                  attrs: { href: "javascript:void(0)" },
                },
                [
                  _vm._v(
                    _vm._s(_vm.whatsappAuthorName) +
                      " - " +
                      _vm._s(_vm.whatsappAuthorNumber)
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t(
        "default",
        function () {
          return [
            _c(
              "div",
              {
                class: { "translatable-content-wrapper": _vm.isTranslatable() },
              },
              [
                _c("SupsisText", {
                  attrs: { visitorId: _vm.visitorId, message: _vm.message },
                  scopedSlots: _vm._u([
                    {
                      key: "content",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              class: {
                                "after-translate-top": _vm.isTranslatable(),
                              },
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column",
                              },
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "sc-message--text-content m-1 ml-3 mr-3",
                                staticStyle: { "word-break": "break-word" },
                                style: { color: _vm.getWhatsappNumberColor() },
                                domProps: {
                                  innerHTML: _vm._s(_vm.messageText),
                                },
                              }),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                }),
                _vm._v(" "),
                _vm.isTranslateOpen && !!_vm.translate
                  ? _c(
                      "div",
                      {
                        class: {
                          "after-translate-bottom": _vm.isTranslatable(),
                        },
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "column",
                          "border-radius": "0",
                        },
                      },
                      [
                        _vm.isTranslatable()
                          ? _c("TranslatedText", {
                              staticClass: "ml-3",
                              attrs: { data: _vm.translate },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.translate &&
                        _vm.isTranslateOpen &&
                        _vm.myLang !== _vm.message.raw.baseLang
                          ? _c(
                              "span",
                              {
                                staticClass: "ml-3 text-info edit-icon",
                                staticStyle: { cursor: "pointer" },
                                on: { click: _vm.translateMsg },
                              },
                              [
                                _vm.translating
                                  ? _c(
                                      "a",
                                      { staticClass: "translate-this-text" },
                                      [
                                        _c("b-spinner", {
                                          staticClass: "align-middle",
                                          attrs: {
                                            small: "",
                                            variant: "danger",
                                            type: "grow",
                                          },
                                        }),
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.$t("message.translating")
                                            ) +
                                            "\n                    "
                                        ),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "a",
                                      { staticClass: "translate-this-text" },
                                      [
                                        _c("span", { staticClass: "md-icon" }, [
                                          _vm._v("translate"),
                                        ]),
                                      ]
                                    ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: {
                      "after-translate-bottom":
                        !!_vm.translate && _vm.isTranslateOpen,
                    },
                    staticStyle: {
                      display: "flex",
                      "flex-direction": "row",
                      "justify-content": "end",
                      "align-items": "center",
                      padding: "0 0.3rem",
                    },
                  },
                  [
                    _vm.message.data.meta
                      ? _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  content: _vm.formatDate(_vm.message),
                                  followCursor: true,
                                  placement: "top",
                                },
                                expression:
                                  "{\n                        content: formatDate(message),\n                        followCursor: true,\n                        placement: 'top',\n                    }",
                              },
                            ],
                            staticClass: "sc-message-meta-new",
                            style: { color: _vm.getWhatsappNumberColor() },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.metaShorter(_vm.message.data.meta)) +
                                "\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.message.data.meta2
                      ? _c(
                          "span",
                          {
                            staticClass: "sc-message--meta2",
                            style: { color: _vm.getWhatsappNumberColor() },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.message.data.meta2) +
                                "\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isGroupMessage
                      ? _c(
                          "span",
                          {
                            staticClass: "sc-message-meta-new whatsapp-number",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                _vm.showWhatsappChatStarterModal = true
                              },
                            },
                          },
                          [
                            _c(
                              "a",
                              {
                                style: { color: _vm.getWhatsappNumberColor() },
                                attrs: { href: "javascript:void(0)" },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.whatsappAuthorName) +
                                    " - " +
                                    _vm._s(_vm.whatsappAuthorNumber)
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ],
              1
            ),
          ]
        },
        {
          me: _vm.me,
          message: _vm.message,
          messageColors: _vm.messageColors,
          messageText: _vm.messageText,
        }
      ),
      _vm._v(" "),
      _vm.showWhatsappChatStarterModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("message.whatsappChatStart"),
                showFooter: false,
              },
              on: {
                cancel: function ($event) {
                  _vm.showWhatsappChatStarterModal = false
                },
              },
            },
            [
              _c("WhatsappChatStarter", {
                attrs: {
                  "default-phone-number": _vm.whatsappAuthorNumber,
                  "channel-override": "",
                  "phone-number-override": "",
                  "default-name": _vm.whatsappAuthorName,
                },
                on: {
                  close: function ($event) {
                    _vm.showWhatsappChatStarterModal = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }